import cx from 'classnames'
import { useRef, useState } from 'react'
import { MdExpandMore } from 'react-icons/md'

import { useClickOutside } from '../../../../hooks'

import styles from './year-picker.module.css'

export interface Option {
  value: number
  label?: string
  helperText?: string
}

interface Props {
  options: Option[]
  onChange: (id: number) => void
  selected: number
}

export function YearPicker ({ options, onChange, selected }: Props): JSX.Element {
  let [ open, setOpen ] = useState(false)
  let bodyRef = useRef<HTMLButtonElement>(null)

  function handleClick (id: number): () => void {
    return () => {
      setOpen(false)
      onChange(id)
    }
  }

  useClickOutside(bodyRef, () => {
    setOpen(false)
  })

  return (
    <button
      className={styles.wrapper}
      onClick={() => setOpen(!open)}
      ref={bodyRef}
    >
      <span className={styles.year}>Year</span>
      <MdExpandMore fill='#fff' />
      {open && (
        <div className={styles.selectWrapper} >
          {options.map(({ value, label }) => (
            <button
              key={value}
              className={cx(styles.selectButton, {
                [styles.active as string]: value === selected
              })}
              onClick={handleClick(value)}
            >
              <span className={styles.label}>{label}</span>
            </button>
          ))}
        </div>
      )}
    </button>
  )
}
